import { Pipe, PipeTransform } from '@angular/core';
import { ApiClient } from '@k2/common/backend/api-client';

@Pipe({
    name: 'apiUrl',
    standalone: false
})
export class ApiUrlPipe implements PipeTransform {
  constructor(private apiClient: ApiClient) {}

  transform(url: string): string {
    return this.apiClient.toUrl(url);
  }
}
